import React from 'react';
import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseLeadPage,
  CarleadStepCompoundBuyCarConsentCustomerPopup,
  CarleadTopBlueCarHCSliderMap,
} from '@wkda/marketing-components';
import { DEFAULT_SLIDER_SETTINGS } from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseLeadPage
      form={CarleadStepCompoundBuyCarConsentCustomerPopup}
      content={CarleadTopBlueCarHCSliderMap}
      happyCustomerSettingsOverrides={DEFAULT_SLIDER_SETTINGS}
      className='mobile-blue-bg'
      showCounterHeadline={false}
      howItWorksShowCta={true}
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
